/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { CCBAreYouSureComponent} from './CCB_are_you_sure.component';

export class CCBAreYouSureValidation extends IValidator {

       constructor(private component: CCBAreYouSureComponent) {
                 super();
       }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

